const getCognitoUserPool = () => {
  if (
    window.location.hostname.startsWith(process.env.REACT_APP_LOCAL_ENV) ||
    window.location.hostname.startsWith(process.env.REACT_APP_DEV_ENV)
  ) {
    return {
      UserPoolId: process.env.REACT_APP_DEV_COGNITO_USER_POOL_ID,
      ClientId: process.env.REACT_APP_DEV_COGNITO_CLIENT_ID,
      domain: process.env.REACT_APP_DEV_CPMT_COGNITO_DOMAIN,
    };
  }
  if (window.location.hostname.startsWith(process.env.REACT_APP_TEST_ENV)) {
    return {
      UserPoolId: process.env.REACT_APP_TEST_COGNITO_USER_POOL_ID,
      ClientId: process.env.REACT_APP_TEST_COGNITO_CLIENT_ID,
      domain: process.env.REACT_APP_DEV_CPMT_COGNITO_DOMAIN,
    };
  }
  return {
    UserPoolId: process.env.REACT_APP_PROD_COGNITO_USER_POOL_ID,
    ClientId: process.env.REACT_APP_PROD_COGNITO_CLIENT_ID,
    domain: process.env.REACT_APP_PROD_CPMT_COGNITO_DOMAIN,
  };
};
export default getCognitoUserPool;
